export default "/assets/images/CC-stats-graph-sm.4785562c4086f9df.png";